import React from 'react'
import { motion } from "framer-motion";

const HeaderSection = () => {
  return (
    <>
        <motion.h1
          className="text-4xl lg:text-6xl font-extrabold text-green-400 mb-4 text-center"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          Get In Touch
        </motion.h1>
        <motion.p
          className="text-lg lg:text-xl text-gray-300 text-center mb-10 max-w-2xl"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          At Beyond Bloom, we’re dedicated to helping you grow and thrive. Reach
          out to us for expert advice, project collaborations, or to simply say
          hello!
        </motion.p>

    </>
  )
}

export default HeaderSection